import React, { useEffect } from 'react';

import { useClassroomInterruption, useCountdownTimer } from 'Util/Hooks';
import { AccessContentModal, MESSAGE_TYPE } from 'Components/AccessContentModal';

const UnAuthorizationModal = ({ onLogout }) => {
  const { isInterrupting, activateInterruption } = useClassroomInterruption();

  const [timeLeft] = useCountdownTimer(15, false, {
    onTimeout: onLogout,
  });

  useEffect(() => {
    activateInterruption();
  }, []);

  return (
    <AccessContentModal
      muiProps={{ isActive: isInterrupting }}
      countDownTimer={`ปิดหน้าต่างอัตโนมัติภายใน ${timeLeft}s`}
      messageType={MESSAGE_TYPE.UNAUTHORIZATION_ERROR}
      onClick={onLogout}
    />
  );
};

export default UnAuthorizationModal;
